import React, {ReactNode} from 'react';

import Icon from '@pb/kit-component-icon';
import Typography from '@pb/kit-component-typography';

import {cardHeader, cardIcon, infoCard} from '../get-started.module.styl';

type InfoCardProps = {
    icon: string,
    title: string,
    children: ReactNode,
};

export const InfoCard: React.FC<InfoCardProps> = ({icon, title, children}) => {
    return (
        <div className={infoCard}>
            <div className={cardHeader}>
                <div className={cardIcon}>
                    <Icon type={icon} size="Size_19"/>
                </div>
                <Typography variant="heading-level-3">{title}</Typography>
            </div>
            {children}
        </div>
    );
};
